<template>
  <form class="booking-form">
    <div class="booking-form__fields">
      <Count class="booking-form__quantity" v-model="quantity" />
      <InputData class="booking-form__date" label="Дата посещения" placeholder="Дата" v-model="date" />
      <Input class="booking-form__time" label="Время посещения" placeholder="Время" v-model="time" v-maska="'##:##'" />
      <Input class="booking-form__name" :status="errors.name ? 'error': ''" label="Ваше имя" placeholder="Имя"
        v-model="name" required />
      <Input class="booking-form__phone" :status="errors.phone ? 'error': ''" label="Ваш телефон" placeholder="Телефон"
        v-model="phone" v-maska="'+7 (###) ###-##-##'" required />
    </div>
    <div class="booking-form-control">
      <Button class="booking-form__bnt" @click.prevent="submit">{{ getValue('bnt') }}</Button>
      <p class="booking-form__desc">Нажимая “{{ getValue('bnt') }}” вы даете согласие на обработку персональных
        данных</p>
    </div>
  </form>
</template>

<script>
import Input from "@/components/element/InputApp.vue";
import InputData from "@/components/element/DataApp.vue";
import Count from "@/components/element/CountApp.vue";
import Button from "@/components/element/ButtonApp.vue";
import { getValue } from '@/helpers/index.js';
import { validation } from "@/helpers/index.js";

export default {
  name: 'BookingForm',
  components: {
    Input,
    Button,
    Count,
    InputData
  },
  props: {
    content: {
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      quantity: null,
      date: null,
      time: null,
      name: "",
      phone: "",
      errors: {
        name: false,
        phone: false,
      }
    }
  },
  computed: {
    getValue() {
      return (path) => {
        return getValue(this.content, path, "");
      }
    },
  },
  methods: {
    submit() {
      let isSubmit = true;
      this.errors = { name: false, phone: false };

      if (!validation(this.name, null)) {
        this.errors.name = true;
        isSubmit = false;
      }

      if (!validation(this.phone, 'phone')) {
        this.errors.phone = true;
        isSubmit = false;
      }

      if (isSubmit) {
        this.$store.dispatch("submitForm", {
          id: 833,
          custom_name: this.name,
          custom_phone: this.phone,
          custom_quantity: this.quantity,
          custom_date: this.date,
          custom_time: this.time,
        });

        this.$store.commit('updatePopup', {
          status: 'success',
          data: this.getValue('success')
        });

        this.quantity = null;
        this.date = '';
        this.time = null;
        this.name = "",
          this.phone = "",
          this.errors = {
            name: false,
            phone: false,
          }

        let context = this;

        setTimeout(() => {
          context.$store.commit('updateClose', null);
        }, 2000)

      }
    }
  },
};
</script>
<style>
.booking-form__fields {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 50px;
}

.booking-form__quantity {
  width: 30% !important;
  margin-bottom: 40px;
}

.booking-form__date {
  width: 30%;
  margin-bottom: 40px;
}

.booking-form__time {
  width: 30%;
  margin-bottom: 40px;
}

.booking-form__name {
  width: 47%;
}

.booking-form__phone {
  width: 47%;
}

.booking-form-control {
  display: flex;
  align-items: center;
}

.booking-form__bnt {
  margin-right: 100px;
}

.booking-form__desc {
  width: 362px;

  font-size: 14px;
  color: #858993;
}

@media screen and (max-width: 1919.98px) {
  .booking-form__fields {
    margin-bottom: 45px;
  }

  .booking-form__quantity {
    margin-bottom: 30px;
  }

  .booking-form__date {
    margin-bottom: 30px;
  }

  .booking-form__time {
    margin-bottom: 30px;
  }

  .booking-form__bnt {
    margin-right: 75px;
  }

  .booking-form__desc {
    width: 300px;
  }
}

@media screen and (max-width: 1599.98px) {
  .booking-form__fields {
    margin-bottom: 40px;
  }

  .booking-form__quantity {
    margin-bottom: 25px;
  }

  .booking-form__date {
    margin-bottom: 25px;
  }

  .booking-form__time {
    margin-bottom: 25px;
  }

  .booking-form__bnt {
    margin-right: 58px;
  }

  .booking-form__desc {
    width: 240px;

    font-size: 12px;
  }
}

@media screen and (max-width: 1199.98px) {
  .booking-form__fields {
    margin-bottom: 35px;
  }

  .booking-form__quantity {
    margin-bottom: 20px;
  }

  .booking-form__date {
    margin-bottom: 20px;
  }

  .booking-form__time {
    margin-bottom: 20px;
  }

  .booking-form__desc {
    font-size: 10px;
  }
}

@media screen and (max-width: 991.98px) {
  .booking-form__fields {
    margin-bottom: 30px;
  }

  .booking-form__fields {
    flex-direction: column;
  }

  .booking-form__quantity {
    width: 100% !important;
  }

  .booking-form__date {
    width: 100%;
  }

  .booking-form__time {
    width: 100%;
  }

  .booking-form__name {
    width: 100%;
    margin-bottom: 20px;
  }

  .booking-form__phone {
    width: 100%;
  }

  .booking-form-control {
    flex-direction: column;
    align-items: flex-start;
  }

  .booking-form__bnt {
    margin-right: 0;
    margin-bottom: 15px;
  }
}

@media screen and (max-width: 767.98px) {
  .booking-form__fields {
    margin-bottom: 25px;
  }
}
</style>
